@if (job(); as toolJob) {
  <button
    class="cui-card cui-card--interactive tool-node"
    [cuiDropdownTriggerFor]="actions"
    type="button">
    <header class="cui-card__header tool-node__header">
      <span class="material-symbols-outlined">widgets</span><strong>{{ name() }}</strong>
    </header>
    <dl class="tool-node__entries">
      <dt style="grid-row: 1">Run ID</dt>
      <dd style="grid-row: 1">{{ toolJob.toolJobId }}</dd>
      <dt style="grid-row: 2">Duration</dt>
      <dd style="grid-row: 2">{{ duration(toolJob) }}</dd>
    </dl>
  </button>
  <cui-dropdown #actions>
    <button
      cuiButton
      cdkMenuItem
      class="cui-dropdown__item"
      variant="plain"
      (click)="logsRequested.emit(toolJob.toolJobId)">
      <span class="material-symbols-outlined">assignment</span> Show Logs
    </button>
    @if (rerunStep(); as rerunStep) {
      <button
        cuiButton
        cdkMenuItem
        class="cui-dropdown__item"
        variant="plain"
        (click)="rerunStep()">
        <span class="material-symbols-outlined">replay</span> Re-run step
      </button>
    }
  </cui-dropdown>
} @else {
  <article class="cui-card tool-node tool-node--pending" [class.cui-skeleton]="waitingForTool()">
    <header class="cui-card__header tool-node__header">
      <span class="material-symbols-outlined">widgets</span><strong>{{ name() }}</strong>
    </header>
  </article>
}
